<template>
  <p v-if="author" class="ps-byline">
    Last reviewed:
    <time :datetime="reviewedDate">{{ reviewedLabel }}</time>
    · {{ author.name }} · {{ author.jobTitle }}
  </p>
</template>

<script>
import {
  formatReviewDate,
  getAuthor,
  DEFAULT_AUTHOR_ID,
} from '@/helpers/authors'

// The "Last reviewed / who reviewed it" line under the H1 of the reviewed
// commercial pages. Shared because the whole hub series carries it, and
// because the name it prints has to be the same one <meta name="author">
// carries — both come from helpers/authors.js.
export default {
  name: 'PageByline',
  props: {
    // ISO date, so the <time datetime> attribute is machine-readable.
    reviewedDate: {
      type: String,
      required: true,
    },
    authorId: {
      type: String,
      default: DEFAULT_AUTHOR_ID,
    },
  },
  computed: {
    author() {
      return getAuthor(this.authorId)
    },
    reviewedLabel() {
      return formatReviewDate(this.reviewedDate)
    },
  },
}
</script>

<style lang="scss" scoped>
.ps-byline {
  margin-top: 10px;
  font-size: $ps-text-label;
  line-height: 1.5;
  color: $ps-muted;
}
</style>
